import { prefixObjectValues as pre } from '../utils';

const prefix = 'cme-training-table';

const table = pre(
  {
    grid: 'grid',
    editBtn: 'edit-btn',
    deleteBtn: 'delete-btn',
    addBtn: 'add-btn',
    emptyState: 'empty-state',
  },
  prefix
);

export default {
  ...table,
};
